export default {
    employeeFiledLeaves: [],

    

    // approvers: [],

    calendarLabels: [
        { text: 'Approved' , value : 'approved', color: 'success' },
        { text: 'Unapproved', value: 'unapproved', color: 'danger'},
        { text: 'For Revision', value: 'for revision', color: 'primary'},
    ],
    getAllLeaves:[],
    approvers: [],
    photoUpload:[]
}